import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from '../pipes/pipe-module.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopoverTagsComponent } from './popover-tags/popover-tags.component';
import { LogoutComponent } from './logout/logout.component';
import { SplashComponent } from './splash/splash.component';
import { ShowTermsComponent } from './show-terms/show-terms.component';
import { EmbedVideoComponent } from './embed-video/embed-video.component';
import { BanksComponent } from './banks/banks.component';
import { ChangeAvatarComponent } from './change-avatar/change-avatar.component';
import { FavoriteListComponent } from './favorite-list/favorite-list.component';
import { SuccessfullyActionComponent } from '../componentsWallet/components/successfully-action/successfully-action.component';
import { RechargeComponent } from '../componentsWallet/components/recharge/recharge.component';
import { MultioComponent } from './multio/multio.component';
import { CardsLoadingComponent } from './cards-loading/cards-loading.component';
import { DebitComponent } from './debit/debit.component';
import { ActionClientComponent } from '../componentsWallet/components/action-client/action-client.component';
import { StripeComponent } from './stripe/stripe.component';
import { OptionsComponent } from '../pages/product-detail/components/options/options.component';
import { ConsultBtnComponent } from '../pages/product-detail/components/consult-btn/consult-btn.component';
import { LoadExcelComponent } from './load-excel/load-excel.component';
import { CategoriesProductDetailComponent } from './categories-product-detail/categories-product-detail.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { GiftCardSelectionComponent } from './gift-card-selection/gift-card-selection.component';
import { PaypalComponent } from './paypal/paypal.component';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ZoomImgComponent } from './zoom-img/zoom-img.component';
import { ContactSocialComponent } from './contact-social/contact-social.component';
import { GalleryComponentsModule } from '../gallery-components/gallery-components.module';
import { GeneralesComponentsModule } from '../generales-components/generales-components.module';
import { DirectivesModule } from '../directives/directives.module';
import { ComponentsTermsModule } from '../pages/terms/components-terms/components-terms.module';
import { ComponentsCompraModule } from '../pages/vista-compra/components-compra/components-compra.module';
import { ProductsComponentModule } from '../products-component/products-component.module';
import { BranchComponentsModule } from './change-branch/branch-components/branch-components.module';
import { NgxPayPalModule } from 'ngx-paypal';
import { WompiComponent } from './wompi/wompi.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { YappyComponent } from './yappy/yappy.component';
import { CybersourceComponent } from './cybersource/cybersource.component';
import { QrAfiliadoComponent } from './qr-afiliado/qr-afiliado.component';
import { QRCodeModule } from 'angularx-qrcode';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

const components = [
  PopoverTagsComponent,
  LogoutComponent,
  SplashComponent,
  ShowTermsComponent,
  EmbedVideoComponent,
  BanksComponent,
  ChangeAvatarComponent,
  FavoriteListComponent,
  SuccessfullyActionComponent,
  RechargeComponent,
  MultioComponent,
  CardsLoadingComponent,
  DebitComponent,
  ActionClientComponent,
  StripeComponent,
  YappyComponent,
  CybersourceComponent,
  OptionsComponent,
  ConsultBtnComponent,
  LoadExcelComponent,
  CategoriesProductDetailComponent,
  NotificationsComponent,
  GiftCardSelectionComponent,
  PaypalComponent,
  ZoomImgComponent,
  ContactSocialComponent,
  WompiComponent,
  CheckoutComponent,
  QrAfiliadoComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    PipeModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPayPalModule,
    TranslateModule,
    RouterModule,
    GalleryComponentsModule,
    GeneralesComponentsModule,
    DirectivesModule,
    ComponentsTermsModule,
    ComponentsCompraModule,
    ProductsComponentModule,
    BranchComponentsModule,
    QRCodeModule,
  ],
  exports: components,
})
export class ComponentsModuleModule {}
